import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Tree: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_33545)'>
        <path
          d='M4.37567 13.8192C4.37567 14.1073 4.15549 14.3405 3.88338 14.3405C3.61127 14.3405 3.39109 14.1073 3.39109 13.8192V10.5297C3.39109 10.2415 3.61127 10.0083 3.88338 10.0083H11.0409V8.61717H8.37102C8.09893 8.61717 7.87872 8.38399 7.87872 8.09581V1.47058C7.87872 1.18242 8.09891 0.949219 8.37102 0.949219H14.6269C14.899 0.949219 15.1192 1.1824 15.1192 1.47058V8.09581C15.1192 8.38397 14.899 8.61717 14.6269 8.61717H12.0256V10.0083H19.1831C19.4544 10.0083 19.6754 10.2415 19.6754 10.5297V13.8192C19.6754 14.1073 19.4552 14.3405 19.1831 14.3405C18.911 14.3405 18.6908 14.1073 18.6908 13.8192V11.0502H12.0264V13.8192C12.0264 14.1073 11.8063 14.3405 11.5341 14.3405C11.262 14.3405 11.0418 14.1073 11.0418 13.8192V11.0502H4.37747V13.8192H4.37567ZM16.7221 15.2813H21.5077C21.7798 15.2813 22 15.5144 22 15.8026V22.4279C22 22.716 21.7798 22.9492 21.5077 22.9492H16.7221C16.4501 22.9492 16.2299 22.716 16.2299 22.4279V15.8026C16.2299 15.5145 16.45 15.2813 16.7221 15.2813ZM21.0162 16.324H17.2153V21.9065H21.0162V16.324ZM9.10679 15.2813H13.8923C14.1644 15.2813 14.3846 15.5144 14.3846 15.8026V22.4279C14.3846 22.716 14.1645 22.9492 13.8923 22.9492H9.10679C8.8347 22.9492 8.6145 22.716 8.6145 22.4279V15.8026C8.6145 15.5145 8.83468 15.2813 9.10679 15.2813ZM13.4009 16.324H9.59996V21.9065H13.4009V16.324ZM1.49229 15.2813H6.27785C6.54994 15.2813 6.77015 15.5144 6.77015 15.8026V22.4279C6.77015 22.716 6.54997 22.9492 6.27785 22.9492H1.49229C1.2202 22.9492 1 22.716 1 22.4279V15.8026C1 15.5145 1.22018 15.2813 1.49229 15.2813ZM5.78639 16.324H1.98547V21.9065H5.78639V16.324ZM14.1369 1.99285H8.86567V7.57531H14.1369V1.99285Z'
          fill='url(#paint0_linear_12280_33545)'
          stroke='url(#paint1_linear_12280_33545)'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_33545'
          x1='5.34862'
          y1='2.44937'
          x2='15.6514'
          y2='22.1603'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_33545'
          x1='5.34862'
          y1='2.44937'
          x2='15.6514'
          y2='22.1603'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_33545'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Tree;
